import { render, staticRenderFns } from "./OrderStatistics.vue?vue&type=template&id=28cd0430&scoped=true&"
import script from "./OrderStatistics.vue?vue&type=script&lang=js&"
export * from "./OrderStatistics.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatistics.vue?vue&type=style&index=0&id=28cd0430&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cd0430",
  null
  
)

export default component.exports